import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { useAuth } from '../contexts/AuthContext';

const PermissionRoute = ({ children, resource, action, fallbackPath = '/' }) => {
  const { hasPermission } = usePermissions();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (resource && action && !hasPermission(resource, action)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default PermissionRoute;
